
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/c/home",
      function () {
        return require("private-next-pages/c/home.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/c/home"])
      });
    }
  